import { render, staticRenderFns } from "./Finboard.vue?vue&type=template&id=64d1ca40&"
import script from "./Finboard.vue?vue&type=script&lang=js&"
export * from "./Finboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports